{
  "login": {
    "title": "Sign in",
    "subtitle": "Welcome back to ForumOne",
    "welcomeEmailHint": "Use the temporary password from your welcome email to sign in.",
    "noAccount": "Don't have an account?",
    "signUpLink": "Sign up",
    "email": "Email",
    "identifier": "Email, username, or phone",
    "identifierPlaceholder": "Email, username, or phone number",
    "password": "Password",
    "forgotPassword": "forgot password?",
    "submit": "Login",
    "submitting": "Logging in...",
    "welcomeBack": "Welcome back {{name}}",
    "failed": "Login failed"
  },
  "signup": {
    "title": "Sign up",
    "subtitle": "Create your business or institution account",
    "hasAccount": "Already have an account?",
    "signInLink": "Sign in",
    "fullName": "Full Name",
    "phone": "Phone Number",
    "username": "Username (optional)",
    "usernamePlaceholder": "Choose a username",
    "email": "Email",
    "password": "Password",
    "namePlaceholder": "Name",
    "phonePlaceholder": "Phone",
    "emailPlaceholder": "email",
    "passwordPlaceholder": "password",
    "submit": "Create an account",
    "submitting": "Creating account...",
    "accountCreated": "Account Created Successfully"
  },
  "resetPassword": {
    "documentTitle": "Reset Password",
    "enterEmail": {
      "title": "Enter email",
      "subtitle": "A verification code will be sent to your email"
    },
    "verifyEmail": {
      "title": "Verify email",
      "subtitle": "A verification code has been sent to",
      "fallbackEmail": "your email"
    },
    "newPassword": {
      "title": "Reset password",
      "subtitle": "A verification code will be sent to your email. Enter the code and your new password."
    },
    "fields": {
      "email": {
        "label": "Email",
        "placeholder": "Email"
      },
      "verificationCode": {
        "label": "Verification Code",
        "placeholder": "Code"
      },
      "newPassword": {
        "label": "New Password",
        "placeholder": "New Password"
      },
      "confirmNewPassword": {
        "label": "Confirm Password",
        "placeholder": "Confirm Password"
      }
    },
    "sendEmail": "Send email",
    "retrieving": "retrieving...",
    "verify": "Verify",
    "verifying": "verifying...",
    "backToLogin": "Back to login",
    "toast": {
      "emailSent": "Email sent successfully",
      "requestFailed": "Failed to reset password",
      "sendEmailFailed": "Failed to send email",
      "resetSuccess": "Password reset successfully",
      "duplicateEntry": "Duplicate entry found",
      "accountVerified": "Account verified successfully",
      "verifyFailed": "Failed to verify code"
    }
  },
  "selectBusiness": {
    "documentTitle": "Select Business or Institution",
    "title": "Manage your businesses & institutions in one place",
    "subtitle": "Select a business or institution to get started, or create a new one to expand your presence.",
    "fallbackBusinessName": "Business or Institution",
    "noDescription": "No description",
    "chooseLocation": "Choose a location to continue",
    "createCard": {
      "title": "Create new business or institution",
      "description": "Add another business or institution to your account"
    }
  },
  "selectConsoleScope": {
    "documentTitle": "Choose workspace",
    "title": "Where would you like to go?",
    "subtitle": "You have access to the admin console and to business or institution tools. We'll remember your choice for next time.",
    "adminCard": {
      "title": "Admin console",
      "description": "Manage all businesses & institutions and platform settings.",
      "cta": "Continue as admin"
    },
    "tenantCard": {
      "title": "My Business or Institution",
      "description": "Dashboard, services, appointments, and team tools.",
      "cta": "Continue to Business or Institution"
    },
    "toast": {
      "preferenceSaveError": "Could not save preference. Try again."
    }
  },
  "linkBusinessOwner": {
    "documentTitle": "Link business or institution account",
    "title": "Account already exists",
    "subtitlePrefix": "This email is already registered. If an administrator created your business profile, use the temporary password from your welcome email and",
    "signInLink": "sign in",
    "subtitleSuffix": "instead of signing up again.",
    "secondaryHint": {
      "prefix": "Otherwise, enter your existing password below to add",
      "role": "business or institution owner",
      "suffix": "access to the same login."
    },
    "emailLabel": "Email",
    "nameOnSignupLabel": "Name on sign up",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Your existing password",
    "submit": "Continue",
    "submitting": "Verifying...",
    "wrongEmail": "Wrong email?",
    "backToSignup": "Back to sign up",
    "toast": {
      "startFromSignup": "Start from sign up with your email.",
      "linkedOwnerAccess": "Business or institution owner access linked to your account",
      "linkedVerifyEmail": "Linked — enter the verification code sent to your email",
      "linkError": "Could not link account"
    }
  },
  "common": {
    "or": "or",
    "termsPrefix": "By clicking continue, you agree to our",
    "termsOfService": "Terms of Service",
    "and": "and",
    "privacyPolicy": "Privacy Policy"
  }
}
